import React from 'react';
import './DescriptionValueWithIcon.css';

const DescriptionValueWithIcon = ({value, icon, className}) => {
  return (
    <div className={`policy-description_value-icon-container ${className}`}>
      {value}{icon}
    </div>
  );
};

export default DescriptionValueWithIcon;
